/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useMemo, useState } from 'react';

import { CompanyDraftContent } from '@blockpulse3/graphql/hooks';

import { ISPVFormContext, SPVFormContext, initCompanyDraftContent } from './context';

type Props = {
  draftId: string;
  defaultValues: CompanyDraftContent;
  children: React.ReactNode;
};

/**
 * SPVFormContextProvider.
 * Custom SPVFormContext provider, exposing states for each step of the form.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function SPVFormContextProvider({ draftId, defaultValues, children }: Props): JSX.Element {
  const [companyDraftContent, setCompanyDraftContent] = useState<CompanyDraftContent>(
    defaultValues || initCompanyDraftContent,
  );

  const value = useMemo(
    () => ({
      draftId,
      companyDraftContent,
      setCompanyDraftContent,
    }),
    [companyDraftContent, draftId],
  );

  return <SPVFormContext.Provider value={value}>{children}</SPVFormContext.Provider>;
}

export type SPVFormContextProviderProps = Props;

/**
 * useSPVForm.
 * Custom hook to retrieve the data for each step.
 *
 * @returns {ISPVFormContext}
 */
export function useSPVForm(): ISPVFormContext {
  return useContext(SPVFormContext);
}
